import { useState } from 'react';

const faqs = [
  {
    q: '农民影视需要注册才能观看吗？',
    a: '不需要注册。农民影视所有电影和电视剧均可免费在线观看，打开网站即可即点即播，无需注册、登录或安装任何播放插件。',
  },
  {
    q: '视频播放画质如何？会卡顿吗？',
    a: '全站资源均为高清画质（720P/1080P），采用先进的流媒体传输技术和多线CDN加速，确保播放过程高清流畅不缓冲。建议使用4M以上宽带以获得最佳观影体验。',
  },
  {
    q: '网站资源多久更新一次？',
    a: '内容团队每日更新最新电影和电视剧资源，热门剧集播出后24小时内即可上线。首页会实时推送最新更新内容，确保您不错过任何精彩。',
  },
  {
    q: '是否支持手机和平板观看？',
    a: '完全支持。农民影视网站已全面适配电脑、手机和平板设备，无论在家还是出行途中，随时随地都能享受高清影视内容，自适应屏幕尺寸保障最佳观看效果。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于免费高清影视在线观看的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === idx ? 'rotate-180 text-primary-500' : 'text-foreground-400'
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}